import { ExperienceCategory } from '@/generated/graphql';
import { atom } from 'jotai';

export const experienceCategoryAtom = atom<ExperienceCategory | null>(null);
export const experienceCategoryTabAtom = atom<'upcoming' | 'past'>('upcoming');
